import {
  CUSTOM_ELEMENTS_SCHEMA,
  ModuleWithProviders,
  NgModule,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { EmojiComponent } from "./emoji.component";
import { EmojiService } from "./config/emoji.service";
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [EmojiComponent],
  imports: [CommonModule,FormsModule],
  exports: [EmojiComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [EmojiService],
})
export class EmojiModule {
  static forRoot(): ModuleWithProviders<EmojiModule> {
    return {
      ngModule: EmojiModule,
      providers: [EmojiService],
    };
  }
}
